import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Global } from "@emotion/react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { Environment } from "./index.js";
export const Layout = ({ children, theme }) => (_jsxs(ThemeProvider, { theme: theme, children: [_jsx(CssBaseline, {}), _jsx(Global, { styles: {
                html: {
                    boxSizing: "border-box",
                    WebkitFontSmoothing: "antialiased",
                    MozOsxFontSmoothing: "grayscale",
                },
                body: {
                    fontFamily: '"Lato", sans-serif',
                    margin: 0,
                    background: "#FAFAFA",
                },
                "html, body, #__next, #root": {
                    height: "100%",
                },
            } }), children, _jsx(Environment, {})] }));
//# sourceMappingURL=Layout.js.map